import Home from '@/features/home'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

const router = createBrowserRouter([
	{
		path: '/',
		element: <Home />,
	},
])

const AppRouter = () => {
	return <RouterProvider router={router} />
}

export default AppRouter
